<template>
  <div
    class="homepage"
    style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
  >
  <i class="el-icon-edit"></i>
    <PkHomepageTopBar> </PkHomepageTopBar>
    <div
      style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 92px;"
    >
      <PkHeading> Get home remodeling inspiration </PkHeading>
      <PkHeading level="h3" style="margin-top: 24px;">
        Get inspired by your own neighbours
      </PkHeading>
      <div style="width: 689px; margin-top: 32px;">
        <PkSearchBar placeholder="Enter an address, neighborhood, city, or zip code" mode="rounded">
        </PkSearchBar>
      </div>
      <img class="hero" src="img/neigbourhood-illustration.svg" />
      <div
        style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 92px;"
      >
        <PkHeading level="h2"> Meet your next home remodeling expert </PkHeading>
        <PkTextStyle style="width: 376px; text-align: center;">
          Pickets.com allows homeowners to discover and get inspired by home remodeling projects in
          their own neighborhood.
        </PkTextStyle>
      </div>
      <PkSteps style="margin-top: 60px;" />
      <PkTestamonials style="margin-top: 88px;" />
      <PkHomepageFooter />
    </div>
  </div>
</template>
<script>
export default {
  name: "PkHomepage",
}
</script>
<style scoped>
.homepage {
  background-color: white;
}
.hero {
  width: 100%;
  max-width: 1440px;
}
</style>
<docs>
    ```jsx
    <div>
        <PkHomepage />
    </div>
    ```
</docs>
